class CartBonusPointsRewardsPlusController {
    constructor(trolleyService, settings) {
        this.trolleyService = trolleyService;
        this.settings = settings;
    }

    $onInit() {
        this.setMessage();

    }

    $onChanges() {
        this.setMessage();
    }

    setMessage() {
        this.renderMessage = this.trolleyService.RewardsPlusBonusPointsMessage;
    }
}

const cartBonusPointsRewardsPlusComponentDefinition = {
    bindings: {
        price: '<',
    },
    controller: ['TrolleyService', 'Settings', CartBonusPointsRewardsPlusController],
    template: require('./cart-bonus-points-rewards-plus.component.html').trim(),
};

module.exports = {
    cartBonusPointsRewardsPlusComponentDefinition,
    CartBonusPointsRewardsPlusController,
};




// WEBPACK FOOTER //
// ./src/shop/cart/cart-bonus-points-rewards-plus.component.js